var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48mm",
    height: 181.417,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M98.053 115.562c-8.854 0-16.032-7.068-16.032-15.787 0-8.72 7.178-15.787 16.032-15.787s16.031 7.068 16.031 15.787c0 8.719-7.177 15.787-16.031 15.787m0-35.583c-11.103 0-20.104 8.863-20.104 19.796s9 19.797 20.104 19.797c4.69 0 9.002-1.587 12.423-4.24l12.296 12.11c.363.358.84.537 1.316.537a1.87 1.87 0 0 0 1.316-.537 1.813 1.813 0 0 0 0-2.593l-12.228-12.04c3.099-3.482 4.98-8.04 4.98-13.034 0-10.933-9-19.796-20.103-19.796m0 36.683c9.456 0 17.148-7.576 17.148-16.887 0-9.312-7.692-16.887-17.148-16.887s-17.148 7.575-17.148 16.887c0 9.311 7.692 16.887 17.148 16.887m0-35.584c10.47 0 18.986 8.387 18.986 18.697 0 4.528-1.67 8.9-4.702 12.31l-.69.773.74.728 12.227 12.041c.29.286.29.75 0 1.037a.745.745 0 0 1-.526.215.744.744 0 0 1-.526-.215l-12.297-12.109-.701-.69-.78.604c-3.376 2.619-7.434 4.003-11.731 4.003-10.47 0-18.987-8.388-18.987-18.697 0-10.31 8.517-18.697 18.987-18.697",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.738865
    },
    transform: "translate(-77.95 -79.979)"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.04a64dd2930ff72689fd75619b4a877f.svg";
export { ForwardRef as ReactComponent };